import PropTypes from 'prop-types';
import { Grid, Box, Button, useMediaQuery, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import OrientalImageText from '../../../images/headerthank.svg';
import { COLOR1, COLOR4, RADIO_COLOR } from '../../../constants';
import {
  isCDIraproduct,
  isIRAEducativaProduct,
  useFlowContext,
} from '../../../components/commonCode';

const styledClasses = {
  header: {
    marginBottom: '15px',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    background: '#F8F8F8',
    '@media (max-width:600px)': {
      marginBottom: '0px',
    },
  },
  headerContainer: {
    background: '#FFFFFF',
    width: '100%',
    // paddingTop: '30px',
    paddingBottom: '15px',
    '@media (max-width:600px)': {
      paddingBottom: '0px',
    },
  },
  orientalText: {
    marginLeft: '40px',
    '@media (max-width:600px)': {
      marginLeft: '15px',
    },
    '@media (max-width:350px)': {
      width: 'calc(100% - 15px)',
    },
  },
  button: {
    border: `1.6px solid ${RADIO_COLOR}`,
    borderRadius: '56px',
    opacity: 1,
    margin: '10px 0px 0px 37px',
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: 700,
    fontSize: 12,
    lineHeight: '16px',
    textAlign: 'center',
    color: `${RADIO_COLOR} !important`,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: COLOR4,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '@media (max-width: 600px)': {
      margin: '10px 0px 0px 15px',
    },
  },
};

export default function Header({ disableMargin }) {
  const baseContext = useFlowContext();
  const { productName, currentPage, isMobileApp, wcType } = baseContext;
  const { t } = useTranslation();
  const isCDIRA = isCDIraproduct(productName);
  const isEducativeIRA = isIRAEducativaProduct(productName);
  const iras = isCDIRA || isEducativeIRA;
  const isCatalogue = wcType === 'catalogueWC';
  const themes = useTheme();
  const isMobile = useMediaQuery(themes?.breakpoints?.down('sm'), {
    defaultMatches: true,
  });
  const handleBacktoAccount = () => {
    window.dispatchEvent(
      new CustomEvent('goto-account', {
        bubbles: true,
        composed: true,
      })
    );
  };

  return (
    <Grid
      container
      sx={{
        ...styledClasses.header,
        ...(iras &&
          currentPage === 'certificate-of-deposit-ira' && {
            marginTop: isMobile || isMobileApp ? '-20px' : '-80px',
          }),
      }}
    >
      <Box sx={styledClasses.headerContainer}>
        <div>
          <Box
            component="img"
            src={OrientalImageText}
            alt="FDIC Insured"
            aria-label="FDIC Insured"
            sx={{
              ...styledClasses.orientalText,
              ...(disableMargin && {
                marginLeft: 0,
                '@media (max-width:600px)': {
                  marginLeft: 0,
                },
              }),
              ...(iras &&
                currentPage === 'certificate-of-deposit-ira' && {
                  marginLeft: 0,
                  '@media (max-width:600px)': {
                    marginLeft: '0px',
                  },
                }),
            }}
          />
        </div>
        {!isMobile && !isMobileApp && (
          <Button
            variant="outlined"
            onClick={handleBacktoAccount}
            startIcon={!isCatalogue && <ArrowBackIcon />}
            sx={{
              ...styledClasses.button,
              ...(disableMargin && {
                margin: '10px 0px 0px 0px',
                '@media (max-width: 600px)': {
                  margin: '10px 0px 0px 0px',
                },
              }),
              ...(iras &&
                currentPage === 'certificate-of-deposit-ira' && {
                  margin: '10px 0px 0px 0px',
                  '@media (max-width: 600px)': {
                    margin: '10px 0px 0px 0px',
                  },
                }),
              ...(isCatalogue && {
                border: `1.6px solid ${COLOR1}`,
                color: `${COLOR1} !important`,
                '&:focus': {
                  outline: `2px solid ${COLOR1}`,
                  outlineOffset: '2px',
                },
              }),
            }}
          >
            {' '}
            {t('Back to my accounts', {
              defaultValue: 'Back to my accounts',
            })}{' '}
          </Button>
        )}
      </Box>
    </Grid>
  );
}

Header.propTypes = {
  disableMargin: PropTypes.bool,
};

Header.defaultProps = {
  disableMargin: false,
};
